import { render, staticRenderFns } from "./DaysComparatorChart.vue?vue&type=template&id=5d8aa1b6&"
import script from "./DaysComparatorChart.vue?vue&type=script&lang=ts&"
export * from "./DaysComparatorChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports